import { Link } from "react-router-dom";
import "../css/footer.css";
import translations from "../resources/translations";
import { useEffect } from "react";

export default function Footer({ setLanguage, visitCount }) {
  const currentLanguage = translations[setLanguage] || translations["mr"]; // Default to 'en' if language is not found

  return (
    <div className="footer">
      <div className="container">
        <div className="row">
          <div className="col-lg-3 col-md-6">
            <div className="footer-contact">
              <h2>{currentLanguage.footer?.contactUs}</h2>
              <a
                href="https://www.google.com/maps/search/daji+maharaj+takli/@19.1215822,77.0602008,17z/data=!3m1!4b1?entry=ttu&g_ep=EgoyMDI0MTIwMS4xIKXMDSoASAFQAw%3D%3D"
                target="_blank"
                rel="noopener noreferrer"
              >
                <p>
                  <i className="fa fa-map-marker-alt"></i>
                  {currentLanguage.footer?.address}
                </p>
              </a>
              <a href="tel:+91-9158303000">
                <p>
                  <i className="fa fa-phone"></i>+91-9158303000
                </p>
              </a>

              <a href="mailto:svspgurukul@gmail.com">
                <p>
                  <i className="fa fa-envelope"></i> svspgurukul@gmail.com
                </p>
              </a>
            </div>
          </div>
          <div className="col-lg-3 col-md-6">
            <div className="footer-link">
              <h2>Policy Links</h2>
              <Link to="/terms">Terms and Conditions</Link>
              {/* <a href="/terms">Terms and Conditions</a> */}
              <Link to="/privacy">Privacy Policy</Link>
              <Link to="/refund">Refund Policy</Link>
              <Link to="/return">Return Policy</Link>
              <Link to="/shipping">Shipping Policy</Link>
            </div>
          </div>
          <div className="col-lg-3 col-md-6">
            <div className="footer-contact">
              <h2>Social Links: </h2>

              <div className="footer-social">
                <a
                  className="btn btn-custom"
                  href="https://www.instagram.com/svspgurukul/?igsh=ejdpbzh1OG5qb3Bn#"
                  target="_blank"
                >
                  <i className="fab fa-facebook-f"></i>
                </a>
                <a
                  className="btn btn-custom"
                  href="https://www.instagram.com/svspgurukul/?igsh=ejdpbzh1OG5qb3Bn#"
                  target="_blank"
                >
                  <i className="fab fa-instagram"></i>
                </a>
                <a
                  className="btn btn-custom"
                  href="https://www.youtube.com/@sacchidanandvedswadhyaypra1982"
                  target="_blank"
                >
                  <i className="fab fa-youtube"></i>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="container copyright">
        <div className="row">
          <div className="col-md-4">
            <p>
              &copy; <a href="#"></a>
              {currentLanguage.footer?.copyright}
              &nbsp;
            </p>
          </div>
          <div className="col-md-4">
            <p>Design and Developed by Infoprosys Technologies Pvt Ltd</p>
          </div>
          <div className="col-md-4 text-end flex-visit">
            <p>
              <b>
                <i className="fa fa-users"></i> Total Visitors: {visitCount}
              </b>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
